export default __webpack_public_path__ + "static/media/failed.c8c6d035.png";